import React, { useState, useEffect } from "react";
import { errorAlert, successAlert } from "../services/sweetAlert";
// Image imports
import customerImg from "../assest/images/about-us/customer-img-grp.png";
import contactImg from "../assest/images/contact-us/cloud.webp";
import leftCar from "../assest/images/bike-rider/Left-Car.png";
import tyre from "../assest/images/bike-rider/Left-Car-tyre.png";
import { Helmet } from "react-helmet-async";
import ImgAdven from "../assest/images/banner-img/separtor.png";

import flagImg from "../assest/images/car-img/flg.png";
import carImg2 from "../assest/images/faq-img/hotballon-right.png";

import rightTree from "../assest/images/bike-rider/right.png";
import bgImage from "../assest/images/banner-img/img-three.jpg";

// Gallery imports
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import Loader from "../component/loader.jsx";

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";

// React Icons
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaShareAlt,
} from "react-icons/fa";
import { apiRequest } from "../services/allApi";
import { useLocation } from "react-router-dom";


const About = () => {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [homeData, setHomeData] = useState([]);
  const [teamData, setTeamData] = useState([]);
  const [galleryData, setGalleryData] = useState([]);

  const Gallery = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("gallery");
      setIsLoading(false);
      if (res?.success) {
        setGalleryData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const Home = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("home");
      setIsLoading(false);
      if (res?.success) {
        setHomeData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const Team = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("team-members");
      setIsLoading(false);
      if (res?.success) {
        setTeamData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    Home();
    Team();
    Gallery();
  }, []);

  const [activeSlug, setActiveSlug] = useState("");
  useEffect(() => {
    if (homeData?.cmsPages?.length > 0) {
      setActiveSlug(homeData.cmsPages[0].slug);
    }
  }, [homeData]);

  const activeCMS = homeData?.cmsPages?.find(
    (item) => item.slug === activeSlug,
  );

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>

      <Helmet>
        <title>Local Leh Ladakh Travel Experts | Ladakh MotoDrive</title>

        <meta
          name="description"
          content="Ladakh MotoDrive, a local Leh-based travel company offering bike tours, car trips & custom Ladakh adventures."
        />

        <meta
          name="keywords"
          content="about ladakh motodrive, leh travel company, ladakh tour operator, local ladakh travel agency, leh tour experts"
        />

        <link
          rel="canonical"
          href="https://ladakhmotodrive.com/about-us"
        />

       {/* Open Graph */}
        <meta property="og:title" content="Local Leh Ladakh Travel Experts | Ladakh MotoDrive" />
        <meta property="og:description" content="Ladakh MotoDrive, a local Leh-based travel company offering bike tours, car trips & custom Ladakh adventures." />
        <meta property="og:url" content="https://ladakhmotodrive.com/about-us" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Local Leh Ladakh Travel Experts | Ladakh MotoDrive" />
        <meta name="twitter:description" content="Ladakh MotoDrive, a local Leh-based travel company offering bike tours, car trips & custom Ladakh adventures." />
      </Helmet>
      <div className="container-fulid">
        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />
          </div>
        </div>
        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">About Us</h3>
            <ul className="breadcrumb-menu">
              <li>
                <a className="text-white" href="index.html">
                  Home
                </a>
              </li>
              <li>-</li>
              <li className="active">About Us</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="home-destination">
        <div className="container">
          <div className="row">
            {/* LEFT CONTENT */}
            <div className="col-lg-6">
              <div
                className="about-content"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {/* TITLE */}
                <div className="section-title mb-40">
                  <span>About Us</span>
                  <h2>Ladakh Based Company</h2>

                  <img src={ImgAdven} alt="" />
                </div>

                {/* TABS */}
                {/* <ul className="nav nav-pills" role="tablist">

                    <li className="nav-item">
                    <button
                      className="nav-link"
                      data-bs-toggle="pill"
                      data-bs-target="#focus-customer"
                      type="button"
                    >
                      About Us
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className="nav-link active"
                      data-bs-toggle="pill"
                      data-bs-target="#mission"
                      type="button"
                    >
                      Mission & Vision
                    </button>
                  </li>

                
                </ul> */}
                <ul className="nav nav-pills" role="tablist">
                  {homeData?.cmsPages?.map((item, index) => (
                    <li className="nav-item" key={item.id}>
                      <button
                        className={`nav-link ${
                          activeSlug === item.slug ? "active" : ""
                        }`}
                        type="button"
                        onClick={() => setActiveSlug(item.slug)}
                      >
                        <i className="bi bi-bullseye me-2"></i>
                        {item.title}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="tab-content mt-4">
                  {activeCMS && (
                    <div>
                      {/* <h4>{activeCMS.title}</h4> */}

                      <div
                        dangerouslySetInnerHTML={{
                          __html: activeCMS?.description,
                        }}
                      />
                    </div>
                  )}
                </div>
                {/* TAB CONTENT */}
                <div className="tab-content mt-3">
                  {/* TAB 1 */}
                  <div className="tab-pane fade show active" id="mission">
                    <p>
                      We Don't Just Plan Trips… We Create Mountain Stories."
                      Feel the cold breeze of the Himalayas, the silence of the
                      valleys, and the thrill of high mountain roads. From the
                      royal streets of Leh to the crystal blue beauty of Pangong
                      Lake, From the adventure ride at Khardung La to the
                      magical sand dunes of Nubra Valley — We take you beyond
                      the ordinary Drive or Ride through the scenic highway of
                      Manali, explore the breathtaking route from Srinagar,
                      experience the row beauty of Spite Valley, fell the
                      peaceful night Sky of Hanle, Witness the untouched charm
                      of Tso Moriri, Ride to one of the world's highest
                      Motorable road at Mig La Pass Altitude: (19400)ft (5,913m)
                      and second is Umling La Pass (19024)ft (5,799m) We don't
                      just show you Ladakh… we make you feel it
                    </p>
                  </div>

                  {/* TAB 2 */}
                  <div className="tab-pane fade" id="focus-customer">
                    <ul className="tour-list">
                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>We are not just tour operators.</span>
                      </li>

                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>We are locals of Ladakh.</span>
                      </li>

                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>
                          The roads, the valleys, the culture, the high passes -
                          this is our home. And when you travel with us, you are
                          not just a tourist, you are our guest.
                        </span>
                      </li>

                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>
                          From the peaceful monasteries of Leh to the thrilling
                          heights of Umling La, from the crystal-blue waters of
                          Pangong Lake to the magical sand dunes of Nubra Valley
                          - we design every journey with passion, safety and
                          authenticity.
                        </span>
                      </li>

                      <li>
                        <i className="fas fa-check-circle"></i>
                        <span>
                          We specialize in premium and budget tours - whether
                          it's a bike expedition, a comfortable car tour, a
                          honeymoon escape, or a group adventure with friends.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* BOTTOM */}
                <div className="about-content-bottom mt-5">
                  <a href="/about-us" className="round-btn">
                    More About
                  </a>

                  <div className="counter-area d-flex align-items-center">
                    <div className="customer-img-grp">
                      <img src={customerImg} alt="customers" />
                    </div>

                    <div className="content ms-2">
                      <div className="number d-flex">
                        <h6 className="counter">500</h6>
                        <span>+</span>
                      </div>
                      <p>Customer</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-6 d-flex justify-content-end">
              <div className="about-img">
                <img
                  src={`${BASE_URL}${activeCMS?.image}`}
                  alt={activeCMS?.title}
                />

                {/* <img src={vectorImg} className="vector" alt="vector" /> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="position-relative container-fluid car-travel">
        <div className="marquee-car">
          <div className="motodrive-animated-car">
            <img className="car-main" src={leftCar} alt="car" />

            <span className="tyre-1">
              <img src={tyre} alt="tyre" className="spin-tyres" />
            </span>

            <span className=" tyre-2">
              <img src={tyre} alt=" tyre" className="spin-tyres" />
            </span>
          </div>
        </div>

        <div className="motodrive-right-tree-pic">
          <img src={rightTree} alt="tree" />
        </div>
      </div>

      <section className="team-section position-relative overflow-hidden">
        <div className="flag-img">
          <img src={flagImg} alt="" />
        </div>

        <div className="flag-img-1">
          <img
            className="media-right-ballon move-21 move-2"
            src={carImg2}
            alt=""
          />
        </div>
        <div className="container">
          <div className="text-center mb-5">
            <div className="about-content">
              <div className="section-title mb-40">
                <span>Our Team</span>
                <h2>Meet Our Team</h2>

                <img src={ImgAdven} alt="" />
              </div>
            </div>
          </div>
          <div className="team-grid">
            {teamData.map((member, index) => (
              <div className="team-card" key={index}>
                <div className="team-img">
                  <img src={`${BASE_URL}${member?.image}`} alt="" />

                  {/* Social Icons */}
                  <div className="social-icons">
                    <a href="#">
                      <FaFacebookF />
                    </a>
                    <a href="#">
                      <FaTwitter />
                    </a>
                    <a href="#">
                      <FaLinkedinIn />
                    </a>
                    <a href="#">
                      <FaYoutube />
                    </a>
                  </div>
                </div>

                <h4>{member.name}</h4>
                <span>{member.address}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/*HomeCallback-start*/}

      <section
        className="home-callback  bg-img-fullcallback"
        style={{ backgroundImage: `url(${bgImage})` }}
        data-aos="fade"
      >
        <div className="overlay"></div>

        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <div className="callback-content">
                {/* Video Button */}
                <div
                  className="video-button"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <a
                    id="video-container"
                    data-fancybox="video-gallery"
                    href="https://www.youtube.com/watch?v=2OYar8OHEOU"
                  >
                    <i className="fas fa-play"></i>
                  </a>
                </div>

                <h2
                  className="section-title"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  ARE YOU READY TO TRAVEL? REMEMBER US !!
                </h2>

                <p data-aos="fade-up" data-aos-delay="400">
                  Discover the magic of Leh and Ladakh with unforgettable road
                  trips, breathtaking mountain views, and thrilling adventures.
                  Ladakh MotoDrive offers reliable vehicles, experienced guides,
                  and customized travel experiences to make your journey across
                  the Himalayas safe, comfortable, and truly memorable.
                </p>

                <div
                  className="callback-btn"
                  data-aos="fade-up"
                  data-aos-delay="500"
                >
                  <a href="#" className="round-btn">
                    View Packages
                  </a>

                  <a href="/about-us" className="outline-btn outline-btn-white">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Counter Section */}
      <div className="home-counter">
        <div className="container">
          <div className="counter-wrap">
            <div className="counter-item">
              <span className="counter-no">
                <span className="counter">80</span>K+
              </span>
              <span className="counter-desc">SATISFIED CUSTOMER</span>
            </div>

            <div className="counter-item">
              <span className="counter-no">
                <span className="counter">18</span>+
              </span>
              <span className="counter-desc">ACTIVE MEMBERS</span>
            </div>

            <div className="counter-item">
              <span className="counter-no">
                <span className="counter">220</span>+
              </span>
              <span className="counter-desc">TOUR DESTINATION</span>
            </div>

            <div className="counter-item">
              <span className="counter-no">
                <span className="counter">75</span>+
              </span>
              <span className="counter-desc">TRAVEL GUIDES</span>
            </div>
          </div>
        </div>
      </div>

      {/*gallary-section-start*/}

      <section className="home-gallery home-destination">
        <div className="container">
          <div className="text-center mb-5">
            <div className="about-content">
              <div className="section-title mb-40">
                <span>Gallary</span>
                <h2>PHOTO'S FROM TRAVELLERS</h2>
              </div>
            </div>
          </div>
          <LightGallery
            className="lightgallery-box" // आपका ओरिजिनल क्लास
            speed={500} // आपकी स्पीड
            plugins={[lgThumbnail, lgZoom]} // आपके प्लगइन्स
            elementClassNames="row" // आपका रो सिस्टम
          >
            {/* यहाँ मैप शुरू होता है */}
            {galleryData && galleryData.length > 0 ? (
              galleryData.map((item, index) => (
                <a
                  key={index}
                  href={`${BASE_URL}${item.image}`} // इमेज का बड़ा वर्ज़न
                  className="col-lg-4 mb-4" // बूटस्ट्रैप कॉलम
                >
                  <img
                    src={`${BASE_URL}${item.image}`} // थंबनेल इमेज
                    className="lightgallery-box-img img-fluid rounded"
                    alt={`img-${index}`}
                  />
                </a>
              ))
            ) : (
              <p className="text-center w-100">Loading Images...</p>
            )}
          </LightGallery>
        </div>
      </section>
      {/*gallary-section-end*/}

      {/*testimonial-sections-start*/}
      <section className="home-testimonial bg-light  home-blog">
        <div className="container">
          {/* Heading */}
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <div className="section-heading">
                <div className="section-title mb-40">
                  <span>CLIENT'S REVIEWS</span>
                </div>

                <h2 className="section-title">TRAVELLER'S TESTIMONIAL</h2>

                <p>
                  Fusce hic augue velit wisi quibusdam pariatur, iusto primis,
                  nec nemo, rutrum.
                </p>
              </div>
            </div>
          </div>

          {/* Slider */}
          <div className="testimonial-section">
            <Swiper
              modules={[]}
              spaceBetween={30}
              slidesPerView={3}
              autoplay={{ delay: 3000 }}
              loop={true}
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
            >
              {homeData?.reviews?.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="testimonial-item">
                    <div className="testimonial-content">
                      <div className="rating-start-wrap">
                        <div className="rating-start">
                          <span style={{ width: "80%" }}></span>
                        </div>
                      </div>

                      <p>{item.text}</p>

                      <div className="author-content">
                        <figure className="testimonial-img">
                          <img
                            src={`${BASE_URL}${item.image}`}
                            alt={item.name}
                          />
                        </figure>
                        <div className="author-name">
                          <h4>{item.name}</h4>
                          <h6>{item.position}</h6>
                        </div>

                        <div className="author-name">
                          <h5
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                          <span>{item.role}</span>
                        </div>
                      </div>

                      <div className="testimonial-icon">
                        <i className="fas fa-quote-left"></i>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>

      {/*testimonial-section-end*/}
    </>
  );
};

export default About;
